export function updateUserLikes(firestore, user, baby, event) {
    return firestore.collection("Users").doc(user.email).update({
        liked_events: [...baby, event]
    });
}
